export default {
  name: '404'
   
}



// WEBPACK FOOTER //
// ./src/components/404/loginn.js